export class SseReconnectPolicy {
  private attempts = 0;
  private stableTimer: ReturnType<typeof setTimeout> | null = null;

  /** Опциональный колбэк: вызывается вместе со сбросом attempts, после 10s стабильного соединения. */
  onStable?: () => void;

  /** Задержка перед следующей попыткой: 1s, 2s, 4s ... максимум 30s, с джиттером. */
  nextDelayMs(): number {
    const delay = Math.min(30_000, 1_000 * 2 ** this.attempts) + Math.random() * 500;
    this.attempts += 1;
    return delay;
  }

  /** Вызывать в onopen: счётчик сбрасывается только если соединение прожило 10s. */
  onOpen(): void {
    this.clearStableTimer();
    this.stableTimer = setTimeout(() => {
      this.attempts = 0;
      this.onStable?.();
    }, 10_000);
  }

  /** Вызывать в onerror и в cleanup. */
  onErrorOrClose(): void { this.clearStableTimer(); }

  private clearStableTimer(): void {
    if (this.stableTimer) { clearTimeout(this.stableTimer); this.stableTimer = null; }
  }
}
